/* eslint-disable react/prop-types */
import { createContext } from "react";

export const AppContext = createContext();

const AppContextProvider = (props) => {
  const currency = import.meta.env.VITE_CURRENCY;
  const backendUrl = import.meta.env.VITE_BACKEND_URL;

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Function to format the date eg. ( 20_01_2000 => 20 Jan 2000 )
  const slotDateFormat = (slotDate) => {
    if (!slotDate) return "N/A";

    // Handle DD_MM_YYYY format (e.g., "20_01_2000")
    if (slotDate.includes("_")) {
      const dateArray = slotDate.split("_");
      // Subtract 1 from month because array is 0-indexed (Jan = 0, Dec = 11)
      const monthIndex = Number(dateArray[1]) - 1;
      return dateArray[0] + " " + months[monthIndex] + " " + dateArray[2];
    }

    // Handle ISO date format (e.g., "2026-05-04" or "2026-05-04T00:00:00.000Z")
    try {
      const date = new Date(slotDate);
      if (!isNaN(date.getTime())) {
        const day = date.getDate();
        const monthIndex = date.getMonth();
        const year = date.getFullYear();
        return day + " " + months[monthIndex] + " " + year;
      }
    } catch (e) {
      // If parsing fails, return as is
    }

    return slotDate;
  };

  // Function to calculate the age eg. ( 20_01_2000 => 24 )
  const calculateAge = (dob) => {
    const today = new Date();
    const birthDate = new Date(dob);
    let age = today.getFullYear() - birthDate.getFullYear();
    return age;
  };

  const value = {
    backendUrl,
    currency,
    slotDateFormat,
    calculateAge,
  };

  return (
    <AppContext.Provider value={value}>{props.children}</AppContext.Provider>
  );
};

export default AppContextProvider;
